// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Cqm7G","title":"AfterFrontImage_title__3npdX"};